import React, {Fragment, useState} from 'react';
import { useForm } from 'react-hook-form';
import WEDDING_CONFIG from '../../../../wedding-config';
import TextInput from "../../partials/TextInput";
import SimpleDialog from "../../../../common/SimpleDialog";
import {CommonOutlinedButton} from "../../../../common/StyledButton";
import {addSet} from "../../../../actions/accommodation.actions";
import store from "../../../../store";

const colors = WEDDING_CONFIG.colors;

const AccommodationSetDialog = ({ placeId, handleClose }) => {
    const { register, handleSubmit, errors, getValues, setValue, formState } = useForm({
        mode: 'onChange',
        defaultValues: {
            name: 'Plan noclegowy',
        }
    }); // initialise the hook
    const [isLoading, setIsLoading] = useState(false);
    const onSubmit = data => {
        setIsLoading(true);
        store.dispatch(addSet(data))
            .then(() => {
                setIsLoading(false);
                handleClose();
            });
    };
    let formRef;

    return (
        <SimpleDialog
            open={true}
            title={'Dodaj plan noclegowy'}
            subTitle={<div>Stwórz plan, a następnie dodawaj miejsca i pokoje.</div>}
            actions={<Fragment>
                <CommonOutlinedButton onClick={() => handleClose()} color="secondary">
                    Anuluj
                </CommonOutlinedButton>
                <CommonOutlinedButton className={'fill-primary'} disabled={!formState.isValid || isLoading} onClick={() => formRef.dispatchEvent(new Event('submit', { cancelable: true }))} color="primary">
                    Zapisz
                </CommonOutlinedButton>
            </Fragment>}
            handleClose={handleClose}>
            <form onSubmit={handleSubmit(onSubmit)} ref={(ref) => formRef = ref}>
                <TextInput
                    inputRef={register({required: true})}
                    name="name"
                    key="name"
                    autoFocus
                    label={'Nazwa'}
                    maxLength={16}
                    placeholder={''}
                />
            </form>
        </SimpleDialog>
    )
};

export default AccommodationSetDialog;
